
 
export const FETCH_WARDS_REQUEST = 'wards/FETCH_WARDS_REQUEST';
export const FETCH_WARDS_SUCCESS = 'wards/FETCH_WARDS_SUCCESS';
export const FETCH_WARDS_FAILURE = 'wards/FETCH_WARDS_FAILURE';

 
export const FETCH_WARD_REQUEST = 'wards/FETCH_WARD_REQUEST';
export const FETCH_WARD_SUCCESS = 'wards/FETCH_WARD_SUCCESS';
export const FETCH_WARD_FAILURE = 'wards/FETCH_WARD_FAILURE';

 
export const DELETE_WARD_REQUEST = 'wards/DELETE_WARD_REQUEST';
export const DELETE_WARD_SUCCESS = 'wards/DELETE_WARD_SUCCESS';
export const DELETE_WARD_FAILURE = 'wards/DELETE_WARD_FAILURE';

 
export const CREATE_WARD_REQUEST = 'wards/CREATE_WARD_REQUEST';
export const CREATE_WARD_SUCCESS = 'wards/CREATE_WARD_SUCCESS';
export const CREATE_WARD_FAILURE = 'wards/CREATE_WARD_FAILURE';

 
export const UPDATE_WARD_REQUEST = 'wards/UPDATE_WARD_REQUEST';
export const UPDATE_WARD_SUCCESS = 'wards/UPDATE_WARD_SUCCESS';
export const UPDATE_WARD_FAILURE = 'wards/UPDATE_WARD_FAILURE';


export const UPDATE_FIELD = 'wards/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'wards/SET_DEFAULT_DATA';
